var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#BD4C31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.27-190.91q-15.49 0-25.95-10.54-10.46-10.54-10.46-25.98v-530.83q0-15.53 10.58-25.91 10.57-10.37 26.06-10.37 15.49 0 25.83 10.37 10.34 10.38 10.34 25.91V-394h344.95v-241.46q0-31.32 22.17-53.54 22.18-22.21 53.74-22.21H770q64.41 0 110.27 45.87 45.87 45.86 45.87 110.27v327.87q0 15.54-10.41 25.91-10.41 10.38-25.99 10.38-15.49 0-25.95-10.54-10.46-10.54-10.46-25.98v-90.82H106.67v91.05q0 15.54-10.41 25.91-10.41 10.38-25.99 10.38Zm204.75-253.5q-48 0-80.97-32.93-32.98-32.94-32.98-80.94t32.94-80.8q32.93-32.8 80.94-32.8 48 0 80.8 32.76 32.79 32.76 32.79 80.77 0 48-32.76 80.97t-80.76 32.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.a86c871626053d7b5c1a8553c113e3bb.svg";
export { ForwardRef as ReactComponent };